import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspHomeService {
  paramData: any;
  constructor(
    private http: HttpClient,

  ) { }
  
  popularBrandsAndCategory(){
      this.paramData = {
        authKey: GlobalVariable.AUTH_KEY,
        source: "web" 
      };

      // console.log(this.paramData);
      // console.log('-----Popular Brands And Category-----------');    
      return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/popularBrandsAndCategory', this.paramData);
  }

  getAllCategories(){
    this.paramData = {
      authKey: GlobalVariable.AUTH_KEY,
      source: "web" 
    };

    // console.log(this.paramData);
    // console.log('-----Popular Brands And Category-----------');    
    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/categories/all', this.paramData);
  }

  

  regDecode(regNo){
    this.paramData = {source: "web" };

    // console.log(this.paramData);
    // console.log('-----Registration Decode-----------');    
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/vehicle/decode/v2/'+regNo, this.paramData);
  }
  getGarageMetrics(garageKey: string, userKey: string, filterWith: string) {

    this.paramData = {
      garageKey: garageKey,
      userKey: userKey,
      filterWith: filterWith
    };

    // console.log('-----Garage Metrics-----------');    

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}` + '/garage/get/metrics',
      this.paramData
    );
  }
  getBrandSpares(page: number = 0, size: number = 20, brand: string = 'Autoverse') {
    // Take garageKey from localStorage
    const garageKey = localStorage.getItem('garageKey') || '';

    this.paramData = {
      brand: brand,
      categoryFilter: [],
      garageKey: garageKey,
      plannedSku: false,
      rowKey: '',
      searchKey: '',
      sortingField: 'sold_quantity',
      sortingOption: 'desc',
      universal: false,
      variantKey: '',
      deviceId: '',
      deviceName: 'web_browser',
      source: 'web',
      page: page,
      size: size
    };

    // console.log('-----Get Brand Spares-----------', this.paramData);

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}/spare/getBrandSpares?page=${page}&size=${size}`,
      this.paramData
    );
  }
  getServiceKits() {
  const garageKey = localStorage.getItem('garageKey') || '';
  const variantKey = localStorage.getItem('variantKey') || '';
  const rowKey = localStorage.getItem('rowKey') || '';

  this.paramData = {
    decode: false,
    garageKey: garageKey,
    registrationNumber: "",
    rowKey: rowKey,
    variantKey: variantKey,
    deviceId: "",
    deviceName: "web_browser",
    source: "web"
  };

  // console.log('-----Get Service Kits-----------', this.paramData);

  return this.http.get(
    `${GlobalVariable.BASE_API_URL_SPARES}/spare/kit`,
    this.paramData
  );
}
getBrandSection() {
  // console.log('-----Get Brand Section API Called-----------');

  return this.http.get(
    `${GlobalVariable.BASE_API_URL_SPARES}/getBrandSection`
  );
}
}
